export const titleMotion = {
    initial: {
        opacity: 0,
        y: 20,
    },
    animate: {
       opacity: 1,
       y: 0,
       transition: {
           duration: .2,
           delay: 1, 
       }
    },
    exit: {
        opacity: 0,
        transition: {
            duration: .5
        }
    }
}

export const optionsContainerMotion = {
    initial: {},
    animate: {
        transition: {
            staggerChildren: .2,
            delayChildren: 1.2,
        }
    },
    exit: {}
}

export const optionMotion = {
    initial: {
        opacity: 0,
    },
    animate: {
       opacity: 1,
       ease: [0.99, 0.15, 0, 0.86],
    },
    exit: {
        opacity: 0,
        transition: {
            duration: .5
        }
    }
}